import { PlatformLanguage } from "@/generated-api/models/PlatformLanguage";
import { TRANSLATIONS } from "@/translations";

/**
 * A hook that provides translations based on the browser's locale
 * Useful for components that are shown to logged out users
 * @returns The translation tree for the detected browser language (with fallback to English)
 */
export const useLocaleTranslation = () => {
  // Get the browser language
  let browserLanguage = PlatformLanguage.ENGLISH; // Default fallback

  // Only access browser APIs if we're in the browser environment
  if (typeof window !== "undefined" && typeof navigator !== "undefined") {
    const locale = navigator.language.split("-")[0].toLowerCase();

    const localeMap: Record<string, PlatformLanguage> = {
      en: PlatformLanguage.ENGLISH,
      ru: PlatformLanguage.RUSSIAN,
    };
    if (locale in localeMap) {
      browserLanguage = localeMap[locale];
    }
  }

  // Return translations for the detected browser language with fallback to English
  return (
    TRANSLATIONS[browserLanguage] || TRANSLATIONS[PlatformLanguage.ENGLISH]
  );
};
